import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "./landing.css";
import ScrollToExplore from "../../components/ScrollToExplore";
import LandingFooter from "./LandingFooter";
import LandingNav from "./LandingNav";
import { AiSme, Cta, Faq, Features, Hero, How, What } from "./sections";
import { scrollToSection } from "./scroll";
import { useDefaultAppTheme, useLandingFont, useReveal } from "./shared";

export default function Landing() {
  const rootRef = useRef<HTMLDivElement>(null);
  const { hash } = useLocation();

  useDefaultAppTheme();
  useLandingFont();
  useReveal(rootRef);

  // Deep links such as /#features land on the section once it has rendered.
  useEffect(() => {
    if (!hash) return;
    const id = hash.replace("#", "");
    const t = setTimeout(() => scrollToSection(id), 100);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <div className="rl" id="top" ref={rootRef}>
      <LandingNav />
      <main>
        <Hero />
        <What />
        <How />
        <Features />
        <AiSme />
        <Faq />
        <Cta />
      </main>
      <ScrollToExplore />
      <LandingFooter />
    </div>
  );
}
